import { useEffect, useEffectEvent } from 'react';
export const UTHOPP_EVENT_NAME = 'hn-uthopp-show-modal';
export const UTHOPP_CONFIRM_EVENT_NAME = 'hn-uthopp-confirm';
export const UTHOPP_CANCEL_EVENT_NAME = 'hn-uthopp-cancel';
/**
 * Gjør uthopp til ekstern tjeneste.
 */
export const HNeventUthopp = ({ url, resources }) => {
    document.dispatchEvent(new CustomEvent(UTHOPP_EVENT_NAME, { detail: { url, resources } }));
};
/**
 * Lytt på eventer fra uthoppsplakaten
 *
 * @param onConfirm Callback som kalles når brukeren bekrefter uthopp.
 * @param onCancel Callback som kalles når brukeren avbryter uthopp.
 */
export const useUthoppResult = (onConfirm, onCancel) => {
    const handleConfirmed = useEffectEvent((detail) => {
        onConfirm?.(detail);
    });
    const handleCancelled = useEffectEvent((detail) => {
        onCancel?.(detail);
    });
    useEffect(() => {
        const handleConfirm = (event) => {
            handleConfirmed(event.detail);
        };
        const handleCancel = (event) => {
            handleCancelled(event.detail);
        };
        document.addEventListener(UTHOPP_CONFIRM_EVENT_NAME, handleConfirm);
        document.addEventListener(UTHOPP_CANCEL_EVENT_NAME, handleCancel);
        return () => {
            document.removeEventListener(UTHOPP_CONFIRM_EVENT_NAME, handleConfirm);
            document.removeEventListener(UTHOPP_CANCEL_EVENT_NAME, handleCancel);
        };
    }, []);
};
